import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { FormattedMessage } from 'react-intl';
import Heading from '../Heading';
import InputField from '../InputField';
import BackIcon from '../../icons/back.svg';

import PlacemarktIcon from '../../icons/map/pin-red.svg';
import LocationIcon from '../../icons/map/location-green.svg';
import RoutingModeAuto from '../../icons/map/auto.svg';
import RoutingModePedestrian from '../../icons/map/pedestrian.svg';

import styles from './MapRouteWindow.styl';

const cx = classNames.bind(styles);

class RouteWindowWindow extends PureComponent {
  static defaultProps = {
    selectedPolygonId: undefined,
  };

  static propTypes = {
    isPhone: PropTypes.bool,
    selectedPolygonId: PropTypes.any,
    onSelectRoutingMode: PropTypes.func,
    onClickRouteFrom: PropTypes.func,
    onBack: PropTypes.func,
    routingMode: PropTypes.string,
    routeFrom: PropTypes.string,
    routeTo: PropTypes.string,
  };

  state = {};

  onClickRoutingMode = e => {
    const routingMode = e.currentTarget.getAttribute('routing-mode');
    if (routingMode !== this.props.routingMode) {
      this.props.onSelectRoutingMode(routingMode);
    }
  };

  onClickRouteFrom = () => {
    this.props.onClickRouteFrom();
  };

  render() {
    const { routeFrom, routeTo, routingMode, isPhone } = this.props;

    return (
      <div className={cx('RouteWindow', {})}>
        <div className={cx('RouteWindow__back')} onClick={this.props.onBack}>
          <span className={cx('RouteWindow__back-icon')}>
            <BackIcon width={16} height={16} />
          </span>
          <Heading className={cx('RouteWindow__back-label')} tagName="span" level={4}>
            {isPhone ? (
              <FormattedMessage id="page.contacts.map.back" />
            ) : (
              <FormattedMessage id="page.contacts.map.searchRoute" />
            )}
          </Heading>
        </div>

        <div className={cx('RouteWindow__routingModes')}>
          <button
            type="button"
            className={cx('RouteWindow__routingModeBtn', {
              RouteWindow__routingModeBtn_active: routingMode === 'auto',
            })}
            routing-mode="auto"
            onClick={this.onClickRoutingMode}
          >
            <RoutingModeAuto
              width={24}
              height={24}
              className={cx('RouteWindow__routingModeBtnIcon')}
            />
            <span className={cx('RouteWindow__routingModeBtnText')}>
              <FormattedMessage id="page.contacts.map.routingAuto" />
            </span>
          </button>

          <button
            type="button"
            className={cx('RouteWindow__routingModeBtn', {
              RouteWindow__routingModeBtn_active: routingMode === 'pedestrian',
            })}
            routing-mode="pedestrian"
            onClick={this.onClickRoutingMode}
          >
            <RoutingModePedestrian
              width={24}
              height={24}
              className={cx('RouteWindow__routingModeBtnIcon')}
            />
            <span className={cx('RouteWindow__routingModeBtnText')}>
              <FormattedMessage id="page.contacts.map.routingPedestrian" />
            </span>
          </button>
        </div>

        <div className={cx('RouteWindow__fieldRow')}>
          <InputField
            className={cx('RouteWindow__fieldIconPlace')}
            value={routeFrom}
            placeholder=""
            onClick={this.onClickRouteFrom}
            readOnly
          >
            <div className={cx('RouteWindow__fieldIcon')}>
              <LocationIcon width={24} height={24} />
            </div>
          </InputField>
        </div>

        <div className={cx('RouteWindow__fieldRow')}>
          <InputField
            className={cx('RouteWindow__fieldIconPlace')}
            value={routeTo}
            placeholder=""
            readOnly
          >
            <div className={cx('RouteWindow__fieldIcon')}>
              <PlacemarktIcon width={24} height={24} />
            </div>
          </InputField>
        </div>
      </div>
    );
  }
}

export default RouteWindowWindow;
